import { type ReactNode } from 'react'
import { type TeamData } from '@terros/common'
import { usePermissionCheck, useTranslation } from '@front/model'
import { TButton } from '@components'
import { useTeamHierarchyContext } from '../../TeamHierarchyContext'

export const ManageTeamButton = ({ team }: { team: TeamData }): ReactNode => {
  const { t } = useTranslation()
  const { openTeamPanel } = useTeamHierarchyContext()
  const { data: canManage } = usePermissionCheck({ permissionType: 'team:update', targetId: team.teamId })

  if (!canManage) return

  return (
    <TButton
      noTranslation
      buttonType='icon-rounded'
      className='absolute top-2 right-2'
      data-no-pan='true'
      draggable={false}
      icon='settings'
      size='xs'
      tooltip={t('Manage {{name}}', { name: team.name })}
      variant='gray'
      onClick={(e) => {
        e.stopPropagation()
        openTeamPanel(team.teamId)
      }}
    />
  )
}
